export default __webpack_public_path__ + "static/media/KYC.cfd6a7df.png";